import React, { forwardRef, useImperativeHandle } from "react";
import { useErrorInputs } from "../../../hooks/useErrorInputs";
import { useDataAuth } from "../../../hooks/useDataAuth";
import { useStorageManager } from "../hooks/useStorageManager";
import { useFormOptions } from "../hooks/useFormOptions";
import Grid from "@mui/material/Grid";
import { ServiceFields } from "./ServiceFields";
import { TypeSelector } from "./TypeSelector";
import { StorageTable } from "./StorageTable";
import { BasicFields } from "./BasicFields";
import { TaxFields } from "./TaxFields";

const FIELDS_REQUIRED = ["name", "code_sku", "unit_code", "description"];

export const CreateFormService = forwardRef(
    (
        {
            dto,
            configuration,
            handleInputChange,
            handleDirectInputChange,
            handleSearchProduct,
            isEdit,
            taxesSiigo,
        },
        ref
    ) => {
        const [{ userSession }] = useDataAuth();
        // eslint-disable-next-line no-unused-vars
        const [errorInputs, _handleErrorInput, _resetErrors, validForm] = useErrorInputs({});

        const { options } = useFormOptions(dto.id_company, userSession.token);

        const {
            storageList,
            editingItem,
            loading: storageLoading,
            error: storageError,
            handleEdit,
            handleEditChange,
            handleEditSave,
            handleEditCancel,
            handleDelete,
        } = useStorageManager(dto.id_product_service, userSession.token, isEdit);
        useImperativeHandle(ref, () => ({
            getData: () => dto,
            errorInputs,
            validForm: () => validForm(FIELDS_REQUIRED, dto),
        }));

        return (
            <Grid container spacing={1} sx={{ mt: 2 }}>
                <TypeSelector
                    value={dto.type}
                    onChange={handleDirectInputChange}
                />

                <BasicFields
                    dto={dto}
                    errorInputs={errorInputs}
                    units={options.units}
                    brands={options.brands}
                    references={options.references}
                    isEdit={isEdit}
                    handleInputChange={handleInputChange}
                    handleDirectInputChange={handleDirectInputChange}
                    handleSearchProduct={handleSearchProduct}
                />

                <TaxFields
                    dto={dto}
                    errorInputs={errorInputs}
                    taxesSiigo={taxesSiigo}
                    configuration={configuration}
                    handleInputChange={handleInputChange}
                />

                <ServiceFields
                    dto={dto}
                    options={options}
                    handleInputChange={handleInputChange}
                />

                {isEdit && (
                    <StorageTable
                        storageList={storageList}
                        editingItem={editingItem}
                        loading={storageLoading}
                        error={storageError}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        onEditChange={handleEditChange}
                        onEditSave={handleEditSave}
                        onEditCancel={handleEditCancel}
                    />
                )}
            </Grid>
        );
    }
);

CreateFormService.displayName = "CreateFormService";